module.exports = __webpack_public_path__ + "static/media/footer.6d355af9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/reportCards/footer.JPG
// module id = 1215
// module chunks = 0